var React = require('react');

function BringForward (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M512 208v256a48 48 0 0 1-48 48H208a48 48 0 0 1-48-48V352h64v96h224V224h-96v-64h112a48 48 0 0 1 48 48z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M304 352H48a48 48 0 0 1-48-48V48A48 48 0 0 1 48 0h256a48 48 0 0 1 48 48v256a48 48 0 0 1-48 48z","className":"fa-primary","key":2})]);
}

BringForward.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = BringForward;

BringForward.default = BringForward;
